/**
 * Keeps the product page's hardware spec badges and specs table in sync with the
 * selected variant.
 *
 * The theme (assets/global.js) sets the hidden `input[name="id"]` to the new variant id
 * and dispatches a bubbling `change` event on every variant change, for both the
 * dropdown and radio pickers. Listening on `document` rather than binding the input
 * directly means the listener survives the DOM swaps `renderProductInfo()` performs.
 *
 * Every variant's specs are already embedded in the page by snippets/variant-specs.liquid,
 * so updating is a synchronous text swap - no fetch, no flicker.
 */
(function () {
  if (window.__variantSpecsInit) return;
  window.__variantSpecsInit = true;

  var cache = null;

  function specsMap() {
    if (cache) return cache;
    var el = document.querySelector('.variant-specs-data');
    if (!el) return null;
    try {
      cache = JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
    return cache;
  }

  function applyVariantSpecs(variantId) {
    var map = specsMap();
    var specs = map && map[variantId];
    if (!specs) return;

    document.querySelectorAll('[data-variant-spec]').forEach(function (el) {
      var value = specs[el.dataset.variantSpec];
      // An empty value means this spec is metafield-backed and identical across
      // variants, so the server-rendered text must be left untouched.
      if (value) el.textContent = value;
    });
  }

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (target && target.name === 'id' && target.value) {
      applyVariantSpecs(target.value);
    }
  });
})();
